import { useTranslation } from 'react-i18next'
import { getAssetPrefix } from './getAssetPrefix'

type Language = 'fi' | 'sv' | 'en'

const Header = () => {
  const { t, i18n } = useTranslation()
  const language = i18n.language
  const changeLanguage = (lng: Language) => {
    i18n.changeLanguage(lng)
  }

  return (
    <header id="header">
      <img src={`${getAssetPrefix()}/assets/eu-lippu.svg`} alt="eu-lippu" />
      <div className="jarjestelmanNimi">
        <h3>EURA 2021</h3>
      </div>
      <div className="paaOtsikko">
        <h4>{t('headerTitle')}</h4>
      </div>
      <div className="lokalisaatio">
        <div
          style={{ fontWeight: language === 'fi' ? 'bold' : 'normal' }}
          onClick={() => {
            changeLanguage('fi')
          }}
        >
          Suomi
        </div>
        <div
          style={{ fontWeight: language === 'sv' ? 'bold' : 'normal' }}
          onClick={() => {
            changeLanguage('sv')
          }}
        >
          Svenska
        </div>
        <div
          style={{ fontWeight: language === 'en' ? 'bold' : 'normal' }}
          onClick={() => {
            changeLanguage('en')
          }}
        >
          English
        </div>
      </div>
    </header>
  )
}

export default Header
